import { render, staticRenderFns } from "./lessonContent.vue?vue&type=template&id=a4c7c134&scoped=true&"
import script from "./lessonContent.vue?vue&type=script&lang=js&"
export * from "./lessonContent.vue?vue&type=script&lang=js&"
import style0 from "./lessonContent.vue?vue&type=style&index=0&id=a4c7c134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c7c134",
  null
  
)

export default component.exports